import React from "react";
import { Select } from "antd";
import styles from "./doctorSelect.module.scss";

interface doctorRosterInterface {
  doctorId: string;
  doctorName: string;
  mobileNo: string;
  endTime: string;
  startTime: string;
  languages?: [];
  pocoDoctor?: boolean;
  doctorType?: string;
}

interface DoctorSelectProps {
  doctors: doctorRosterInterface[];
  onChange: (doctorId: string) => void;
  onClick: () => void;
}

const DoctorSelect: React.FC<DoctorSelectProps> = ({ doctors, onChange, onClick }) => {
  return (
    <Select
      placeholder="Select Doctor"
      className={styles.select_props}
      onChange={onChange}
      onClick={onClick}
      allowClear
      style={{ width: "100%" }}
    >
      {doctors.map((doctor, index) => (
        <Select.Option key={index} value={doctor.doctorId}>
          <div className={styles.option}>
            <span className={styles.name}>{doctor.doctorName}</span>
            {doctor.doctorType && (
              <span className={styles.specialty}>
                {doctor.doctorType}
              </span>
            )}
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default DoctorSelect;
